module.exports = __webpack_public_path__ + "static/media/vovlo.ff4538d0.png";